// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64(),
  status: __t.string(),
  tradeId: __t.string().name("trade_id"),
  accountId: __t.string().name("account_id"),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp().name("created_at"),
  raw: __t.string(),
});
